<div class="card">
  <app-header
    titulo="Mapeamentos"
    descricao="Gerenciamento de todos os mapeamentos de dados (transformações) dos recursos.">
  </app-header>

  <p-table
    [value]="mapeamentos"
    [loading]="loading"
    styleClass="p-datatable-sm p-datatable-striped"
    [paginator]="true"
    [rows]="20"
    [globalFilterFields]="['nome', 'descricao', 'recursoNome']">

    <ng-template pTemplate="caption">
      <div class="flex justify-content-between align-items-center">
        <p-button
          label="Atualizar"
          icon="pi pi-refresh"
          (onClick)="carregarMapeamentos()"
          [loading]="loading">
        </p-button>
        <!-- Filtro por recurso -->
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
        <th pSortableColumn="recursoNome">Recurso Associado <p-sortIcon field="recursoNome"></p-sortIcon></th>
        <th pSortableColumn="comandoOrigemNome">Comando de Origem <p-sortIcon field="comandoOrigemNome"></p-sortIcon></th>
        <th pSortableColumn="ativo">Status <p-sortIcon field="ativo"></p-sortIcon></th>
        <th style="width: 10rem">Ações</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-mapeamento>
      <tr>
        <td><strong>{{ mapeamento.nome }}</strong></td>
        <td>{{ mapeamento.recursoNome }}</td>
        <td>{{ mapeamento.comandoOrigemNome }}</td>
        <td>
          <p-tag [value]="mapeamento.ativo ? 'Ativo' : 'Inativo'" [severity]="mapeamento.ativo ? 'success' : 'danger'"></p-tag>
        </td>
        <td>
          <button pButton pRipple icon="pi pi-eye" class="p-button-rounded p-button-info p-button-text" (click)="verMapeamento(mapeamento)"></button>
          <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-text"></button>
          <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" (click)="deletarMapeamento(mapeamento)"></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="5" class="text-center p-4">Nenhum mapeamento encontrado.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Dialog para ver o mapeamento -->
<p-dialog header="Detalhes do Mapeamento" [(visible)]="displayDialog" [modal]="true" [style]="{width: '50vw'}">
  <ng-template pTemplate="content" *ngIf="selectedMapeamento">
    <p-table [value]="getMapeamentosArray(selectedMapeamento.mapeamentos)" styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th>Campo Destino</th>
          <th>Campo Origem / Expressão</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-map>
        <tr>
          <td><strong>{{ map.destino }}</strong></td>
          <td><code>{{ map.origem }}</code></td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
